import comp from "./TableBody";
export default comp;
